<template>
    <div class="newLoginBoxPop">
        <div :class="activeTabName=='tab_login'?'newLoginBox':'newLoginBox newLoginBoxOther'">
            <img class="loginbg" src="/static/img/top.png" />
            <div class="newLoginTit" v-show="activeTabName=='tab_login'">
                <div class="titText">登录</div>
                <img class="TitIMg" src="./img/header/icon_img1.png" alt="">
                <div class="titText">
                    Runway 中文站
                    <img class="titMianfei" src="/static/img/icon_img_03.gif" />
                </div>
            </div>
            <div class="panel_subtitle" v-show="activeTabName=='tab_login'"><span class="subtitle_text">Ai视频，认准Runway中文站</span></div>
            <div class="panel_body panel_body2" v-if="activeTabName == 'tab_reg'">
                <div class="panel_title">
                    <span class="title_text">新用户注册</span>
                </div>
                <div class="phone_wrap">
                    <div class="form_item">
                        <el-input v-model="form.phone" placeholder="请输入手机号" clearable></el-input>
                    </div>
                    <div class="form_item">
                        <el-input v-model="form.code" placeholder="请输入6位短信验证码"></el-input>
                        <div class="code_btn">
                            <el-button style="width:108px;height:50px;color:red;" type="text" :disabled="!form.phone || coding"
                                @click="getCode">{{ coding ? '重新获取(' + second + ')' : '获取验证码' }}
                            </el-button>
                        </div>
                    </div>
                    <div class="form_item">
                        <el-input v-model="form.password" type="password" autocomplete="off" placeholder="请输入登录密码"
                            clearable></el-input>
                    </div>
                    <div class="form_item">
                        <el-input v-model="form.password2" type="password" autocomplete="off" placeholder="请再次输入登录密码"
                            clearable></el-input>
                    </div>
                    <el-button style="width:100%;height: 40px;" type="primary" @click="login_reg"
                        :disabled="!form.phone || !form.code || !form.password || !form.password2">注册
                    </el-button>
                    <div class="login_reg">
                        我有账号？<span
                            @click="activeTabName = 'tab_login'; form.password = ''; form.password2 = ''; login_type = 2">账号登录</span>
                    </div>
                </div>
            </div>
            <div class="panel_body panel_body2" v-else-if="activeTabName == 'tab_password'">
                <div class="panel_title">
                  <span class="title_text">重置密码</span>
                </div>
                <div class="phone_wrap">
                  <div class="form_item">
                    <el-input v-model="form.phone" placeholder="请输入手机号" clearable></el-input>
                  </div>
                  <div class="form_item">
                    <el-input v-model="form.code" placeholder="请输入6位短信验证码"></el-input>
                    <div class="code_btn">
                      <el-button style="width:108px;height:50px;" type="text" :disabled="!form.phone||coding"
                                 @click="getCode">{{ coding ? '重新获取(' + second + ')' : '获取验证码' }}
                      </el-button>
                    </div>
                  </div>
                  <div class="form_item">
                    <el-input v-model="form.password" type="password" autocomplete="off" placeholder="请输入新密码"
                              clearable></el-input>
                  </div>
                  <div class="form_item">
                    <el-input v-model="form.password2" type="password" autocomplete="off" placeholder="请再次输入新密码"
                              clearable></el-input>
                  </div>
                  <el-button style="width:100%;height: 40px;"  type="primary" @click="login_reset_passwrod"
                             :disabled="!form.phone||!form.code||!form.password||!form.password2">找回密码
                  </el-button>
                  <div class="login_reg">
                    我有账号？<span
                      @click="activeTabName='tab_login';form.password='';form.password2='';login_type=2">账号登录</span>
                  </div>
                </div>
              </div>
            <div class="phone_wrap" v-else>
                <div class="form_item" style="margin-bottom:16px;">
                    <el-input v-model="form.phone" placeholder="请输入手机号" clearable />
                </div>
                <div class="form_item">
                    <el-input v-model="form.password" type="password" autocomplete="off" placeholder="请输入登录密码"
                        clearable />
                </div>
                <el-button style="width:100%;height: 55px;margin-top: -8px;font-size:16px;" type="danger" @click="login"
                    :disabled="!form.phone || !form.password">
                    登录
                </el-button>
                <div class="login_reg login_reg_other" style="margin-bottom: 20px;">
                    <div>没有账号？<span
                        @click="activeTabName = 'tab_reg'; form.code = ''; form.password = ''; form.password2 = ''">点此注册</span></div>
                    <div>忘记密码？<span
                        @click="activeTabName = 'tab_password'; form.code = ''; form.password = ''; form.password2 = ''">找回密码</span></div>

                    
                </div>
            </div>

            <div class="agreement" :style="activeTabName == 'tab_login' ? '' : 'margin-top:10px'"><span @click="agree = !agree"
                    :class="['selct_icon', { 'selected': agree }]"></span>同意 <a
                    href="https://docs.qq.com/doc/p/197b3c2fc9eeb39f07ad68e055abfdee2d1d23d2" target="_blank">《网络服务协议》</a> 和 <a
                    href="https://docs.qq.com/doc/p/f8423d2e65a222a1cdb1968aa8af746ba5818542" target="_blank">《隐私条款》</a></div>

            <img class="loginbg" src="/static/img/bot.png" />
            <div class="closeLoginPop" @click="closePanel">
                <img src="/static/img/closeLoginIc.png" class="closeIconBtn" alt="">
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        data () {
        return{
            form:{
                    phone: "",
                    code: "",
                    password: "",
                    password2: ""
            },
            activeTabName:'tab_login',
            agree:true,
            second:60,
            coding:false,
            msgTimer:null,
            login_type:1,
            is_ad:0
        }
    },
    methods:{
testPhone() {
    if (!this.form.phone) {
        this.$message({
            message: '请输入手机号',
            type: 'warning',
        })
        return false;
    }
    let myregphone = /^1[0-9]{10}$/;
    if (!myregphone.test(this.form.phone)) {
        this.$message({
            message: '请输入正确的手机号',
            type: 'warning',
        })
        return false;
    } else {
        return true;
    }
},
clearFn() {
    this.coding = false;
    this.second = 60;
    clearInterval(this.msgTimer);
},
getCode() {
    console.log('执行');

    if (!this.testPhone()) {
        return;
    }
    this.coding = true;
    this.form.code = ""
    this.$http.post(`/front/auth/smscode/`, {
        'phone': this.form.phone,
        'tpl_id': SMS_TPL_ID
    }).then(res => {
        if (res.status === "200") {
            this.$message({
                message: '验证码发送成功！',
                type: 'success'
            });
        }
    }).catch(res => {
        this.$message({
            message: res.result,
            type: 'warning',
        })
        this.clearFn();
    })
    this.msgTimer = setInterval(() => {
        this.second--;
        if (this.second == 0) {
            this.clearFn();
        }
    }, 1000)
},
closePanel() {
//   this.show_login = false;
    this.$store.commit('setShowLogin', false)
  this.clearFn()
},

login() {//登录

let data = {
  phone: this.form.phone,
  password: this.form.password
}

this.$http.post(`/front/auth/login/phone/`, data).then(res => {
    if(res.status==200){
        this.clearFn();
        this.$message({
          message: '登录成功！',
          type: 'success'
        });
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user_id", res.data.user_id);
        this.closePanel()
        this.getProfile()
        //重新刷新页面
        location.reload()
    }else{
        this.$message({
          message: res.message,
          type: 'error'
        });
    }
}).catch(res => {
  this.$message({
    message: res.result,
    type: 'warning'
  });
  this.clearFn();
})
},
login_reg() {
  // 注册
  let bd_vid =  this.getCache("bd_vid") || "";
  let qhclickid = this.getCache("qhclickid") || "";
  let sourceid = this.getCache("sourceid") || "";
  let ad_account_id =  this.getCache("ad_account_id") || 0
  let site_id =this.getCache("site_id") || 0
  let keyword =  this.getCache("keyword") || "";
  let data = {
    phone: this.form.phone,
    code: this.form.code,
    password: this.form.password,
    ad_account_id: ad_account_id,
    site_id: site_id,
    keyword: keyword,
    bd_vid: bd_vid, qhclickid: qhclickid, sourceid: sourceid,
    is_ad: this.is_ad
  }

  if (this.form.password !== this.form.password2) {
    this.$message({
      message: "两次密码输入不一样",
      type: 'warning'
    });
    return false;
  }
  this.$http.post('/front/auth/reg/', data).then(res => {
    if(res.status==200){
        this.clearFn();
        this.$message({
        message: '注册成功！',
        type: 'success'
        });
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user_id", res.data.user_id);

        // 执行 必应注册上报
        let msclkid = this.getCache("msclkid") || ""
        if(msclkid !== ""){
        window.uetq = window.uetq || [];window.uetq.push('event', 'signup', {});
        console.log("执行 必应注册上报", window.uetq)
        }

        this.getProfile();
        let href = location.href
        if (href.indexOf(MAIN_URLROOT) > -1) {
        location.replace("/")
        } else {
        location.href = location.href
        }
    }else{
        this.$message({
        message: res.message,
        type: 'warning'
        });
    }
  }).catch(res => {
    this.$message({
      message: res.message,
      type: 'warning'
    });
    this.clearFn();
  })
},
login_reset_passwrod() {
  // 重置密码
  let data = {
    phone: this.form.phone,
    code: this.form.code,
    password: this.form.password
  }
  if (this.form.code.length != 6) {
    this.$message({
      message: "请输入6位验证码",
      type: 'warning'
    });
    return false;
  }
  if (this.form.password !== this.form.password2) {
    this.$message({
      message: "两次密码输入不一样",
      type: 'warning'
    });
    return false;
  }
  this.$http.post('/front/auth/resetpwd/', data).then(res => {
    if(res.status==200){
        this.clearFn();
        this.$message({
          message: '密码重置成功，请登录！',
          type: 'success'
        });
        this.form.password = ''
        this.form.password2 = ''
        this.activeTabName = "tab_login"
        this.login_type = 2
    }else{
        this.$message({
            message: res.message,
            type: 'warning'
        });
    }

  }).catch(res => {
    this.$message({
      message: res.message,
      type: 'warning'
    });
    this.clearFn();
  })
},
getProfile() {
  let invite_code = localStorage.getItem("invite_code") || "";
  this.$http.get(`/front/user/profile/`, {params: {invite_code: invite_code,app_id:APP_ID }}).then(res => {
    if (res.status == '200') {
    //   localStorage.setItem("user_id", res.data.uid);
    //   user_info.value = res.data;
    //   user_login.value = true;
    //   localStorage.setItem("invite_code", res.data.invite_code);
    //   location.reload();
                    this.$store.commit('setUserInfo', res.data)
                    this.$store.commit('setIsLogin', true)
                    this.$store.commit('setShowLogin', false)
                    localStorage.setItem("userinfo", JSON.stringify(res.data));
                    localStorage.setItem("invite_code", res.data.invite_code);
    }
  })
}
    }
    }
</script>

<style lang="scss" scoped>
*{
    padding: 0;
    margin: 0;
}
.newLoginBoxPop {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0,0.5);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;

    .newLoginBox {
        width: 88%;
        // height: 484px;
        background: #fff;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        justify-content: space-between;
        .newLoginTit {
            display: flex;
            align-items: center;
            margin-top: 30px;

            .titText {
                font-size: 24px;
                color: #000;
                position: relative;

                .titMianfei {
                    position: absolute;
                    right: -25px;
                    top: -20px;
                }
            }

            .TitIMg {
                width: 24px;
                height: 24px;
                margin: 0 10px;
                font-size: 0;
                border-radius: 4px;
            }

        }

        .panel_subtitle {
            font-size: 14px;
            line-height: 42px;
              margin-bottom: 11px;
              margin-top: 11px;

            .subtitle_text {
                color: #ec3b3b;
                position: relative;

                &::before,
                &::after {
                    content: "";
                    display: block;
                    width: 46px;
                    height: 2px;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                }

                &::before {
                    left: -57px;
                    background-image: linear-gradient(to right, #f7f7f7, #dcdcdc);
                }

                &::after {
                    right: -57px;
                    background-image: linear-gradient(to right, #dcdcdc, #f7f7f7);
                }
            }
        }

        .phone_wrap {
            width: calc(100% - 60px);
            margin: 0 auto;

            // height: 220px;
            .login_reg {
                font-size: 14px;
                color: #999;
                padding-top: 15px;
                span {
                    color: #ec3b3b;
                    cursor: pointer;
                }
            }
            .login_reg_other{
                display: flex;
                justify-content: space-between;
            }

            .form_item {
                margin-bottom: 25px;
                position: relative;

                :deep(.el-input) {
                    height: 55px;
                    //border-color:  #606266;
                    //color:#606266;
                }

                :deep(.el-input__wrapper) {
                    background: none;
                    border: 1px solid #dcdfe6;
                    box-shadow: 0 0 0 0px #252323 inset !important
                }

                :deep(.is-focus) {
                    background: none;
                    border: 1px solid #409eff;
                    //box-shadow: 0 0 0 px #252323 inset !important
                }

                .code_btn {
                    position: absolute;
                    top: 0;
                    right: 0;

                    &::before {
                        content: "";
                        display: block;
                        height: 24px;
                        border-right: 1px solid #ddd;
                        top: 13px;
                        position: absolute;
                        left: 0;
                    }
                }
            }

            :deep(.el-button--primary) {
                color: #fff !important;
                background-color: #a0cfff !important;
                border-color: #a0cfff !important;
            }

            :deep(.el-input__inner) {
                height: 100%;
                color: #606266;
            }
        }

        .panel_body {
            width: calc(100% - 20px);
            text-align: center;
            position: relative;

            .panel_title {
                color: black;
                //   padding-top: 42px;
                //   line-height: 54px;
                margin-bottom: 10px;
                font-size: 22px;

                .title_text {
                    position: relative;

                    .free_icon {
                        position: absolute;
                        right: -28px;
                        top: -22px;
                    }
                }
            }

            .panel_subtitle {
                font-size: 14px;
                line-height: 42px;
                margin-bottom: 22px;

                .subtitle_text {
                    color: #ec3b3b;
                    position: relative;

                    &::before,
                    &::after {
                        content: "";
                        display: block;
                        width: 46px;
                        height: 2px;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                    }

                    &::before {
                        left: -57px;
                        background-image: linear-gradient(to right, #f7f7f7, #dcdcdc);
                    }

                    &::after {
                        right: -57px;
                        background-image: linear-gradient(to right, #dcdcdc, #f7f7f7);
                    }
                }
            }

            // .code_wrap {
            //   display: block;
            //   margin: 0 auto 3px;
            //   border: 2px solid #e6e6e6;
            //   width: 220px;
            //   height: 220px;
            //   padding: 10px;
            //   position: relative;

            //   .code_img {
            //     width: 100%;
            //     height: 100%;
            //     display: block;
            //     position: relative;
            //     z-index: 2;
            //   }

            //   .scan_result {
            //     position: absolute;
            //     top: 0;
            //     left: 0;
            //     width: 100%;
            //     height: 100%;
            //     text-align: center;
            //     padding-top: 36px;
            //     background-color: rgba(255, 255, 255, 0.95);
            //     z-index: 3;

            //     .success_icon {
            //       width: 70px;
            //     }

            //     .success_text {
            //       font-size: 18px;
            //       color: #07c160;
            //       line-height: 36px;
            //       padding-top: 10px;
            //     }

            //     .success_label {
            //       font-size: 15px;
            //       line-height: 35px;
            //     }

            //     .rescan_btn {
            //       display: inline-block;
            //       font-size: 14px;
            //       line-height: 34px;
            //       color: #576b95;
            //       cursor: pointer;
            //     }
            //   }

            //   .img_loading {
            //     position: absolute;
            //     top: 0;
            //     left: 0;
            //     width: 100%;
            //     height: 100%;
            //     display: flex;
            //     align-items: center;
            //     justify-content: center;

            //     .text-black {
            //       color: #000;
            //       display: block;
            //     }
            //   }

            //   .time_out_cover {
            //     position: absolute;
            //     top: 0;
            //     left: 0;
            //     width: 100%;
            //     height: 100%;
            //     z-index: 5;
            //     cursor: pointer;
            //     background-color: rgba(0, 0, 0, 0.58);
            //     color: #fff;
            //     font-size: 15px;
            //     z-index: 10;

            //     &:hover {
            //       font-size: 16px;
            //       font-weight: bold;
            //     }

            //     display: flex;
            //     align-items: center;
            //     justify-content: center;
            //   }
            // }

            .phone_wrap {
                width: 400px;
                margin: 0 auto;

                // height: 220px;
                .login_reg {
                    color: #999;
                    padding-top: 15px;

                    span {
                        color: #ec3b3b;
                        cursor: pointer;
                    }
                }

                .form_item {
                    margin-bottom: 25px;
                    position: relative;

                    :deep(.el-input) {
                        height: 55px;
                        //border-color:  #606266;
                        //color:#606266;
                    }

                    :deep(.el-input__wrapper) {
                        background: none;
                        border: 1px solid #dcdfe6;
                        box-shadow: 0 0 0 0px #252323 inset !important
                    }

                    :deep(.is-focus) {
                        background: none;
                        border: 1px solid #409eff;
                        //box-shadow: 0 0 0 px #252323 inset !important
                    }

                    .code_btn {
                        position: absolute;
                        top: 0;
                        right: 0;

                        &::before {
                            content: "";
                            display: block;
                            height: 24px;
                            border-right: 1px solid #ddd;
                            top: 13px;
                            position: absolute;
                            left: 0;
                        }
                    }
                }

                :deep(.el-button--primary) {
                    color: #fff !important;
                    background-color: #a0cfff !important;
                    border-color: #a0cfff !important;
                }

                :deep(.el-input__inner) {
                    color: #606266;
                }
            }
        }

        .panel_body2 {
            .panel_title{
                margin-bottom: 30px;
            }
            .phone_wrap {
                //   width: 400px;
                width: calc(100% - 20px);

                //   margin: 10px auto 0;
                // height: 220px;
                .login_reg {

                    color: #999;
                    // padding-top: 38px;

                    span {
                        color: #ec3b3b;
                        cursor: pointer;
                    }
                }

                .form_item {

                    margin-bottom: 16px;
                    position: relative;

                    :deep(.el-input) {
                        height: 55px;
                        //border-color:  #606266;
                        //color:#606266;
                    }

                    .code_btn {
                        position: absolute;
                        top: 0;
                        right: 0;

                        &::before {
                            content: "";
                            display: block;
                            height: 24px;
                            border-right: 1px solid #ddd;
                            top: 13px;
                            position: absolute;
                            left: 0;
                        }
                    }

                    :deep(.el-button--primary) {
                        color: #fff !important;
                        background-color: #a0cfff !important;
                        border-color: #a0cfff !important;
                    }

                    :deep(.el-input__inner) {
                        color: #606266;
                    }
                }

            }
        }

        .agreement {
            width: calc(100% - 60px);
            // padding-top: 32px;
            font-size: 14px;
            color: #aaa;
            // line-height: 32px;
            // text-align: center;
            user-select: none;

            white-space: nowrap;
            margin-bottom: 15px;

            .selct_icon {
                display: inline-block;
                vertical-align: middle;
                margin-top: -3px;
                border: 1px solid #ec3b3b;
                width: 16px;
                height: 16px;
                margin-right: 5px;
                border-radius: 2px;
                cursor: pointer;

                &.selected {
                    background-size: 100% 100%;
                    background-image: url("/static/img/icon_img_05.png");
                    border: none;
                }
            }

            a {
                color: #999;
            }
        }

        .loginbg {
            width: 100%;
            height: 50px;
            font-size: 0 !important;
            overflow: hidden;
        }

        .closeLoginPop {
            width: 25px;
            height: 25px;
            border-radius: 50%;
            background: #fff;
            position: absolute;
            // bottom: -60px;
            // left: 50%;
            // transform: translateX(-50%);
            right: 0px;
            top: -40px;
            display: flex;
            align-items: center;
            justify-content: center;

            .closeIconBtn {
                width: 15px;
                height: 15px;
            }
        }
    }

    .newLoginBoxOther{
        height: 595px;
    }

}
</style>